

import HiringAutomation from '@features/employerOnboarding/components/HiringAutomation/HiringAutomation';;
import { FC } from 'react';
import { EnterpriseTemplate } from '../types';

type TemplateApplicationSettingsTabProps = {
  templateData: EnterpriseTemplate;
};

const TemplateApplicationSettingsTab: FC<
  TemplateApplicationSettingsTabProps
> = ({ templateData }) => {

  return (
    <HiringAutomation
      automationData={templateData}
    />
  );
};

export default TemplateApplicationSettingsTab;
